/*
 * @Author: Asadhcj asadhcj@163.com
 * @Date: 2025-05-30 14:39:01
 * @LastEditors: Asadhcj asadhcj@163.com
 * @LastEditTime: 2026-01-21 14:48:09
 * @FilePath: \betdoce-web\src\api\activity.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from "./request";

export interface ActivityStatusRecord {
  id: number; // 活動ID
  user_id: number; // 用戶ID
  activity_id: number; // 活動ID
  participation_count: number; // 參與次數
  lock_count: number; // 鎖定次數
  accumulated_amount: number; // 累積金額
  target_amount: number; // 目標金額
  end_time: number; // 結束時間
  invite_link: string; // 邀請鏈接
  current_progress: number; // 當前進度
  current_amount: number; // 當前金額
  current_register_num: number; // 當前註冊人數
  is_completed: number; // 是否完成
  short?: string; // 短鏈接
  // 新增字段
  need_recharge?: number; // 是否需要充值
  recharge_end_time?: number; // 充值倒计时结束时间（时间戳，单位毫秒）
  must_recharge_amount?: number; // 充值金额
}

export interface ActivityResponse {
  status_code: number;
  data: {
    is_new_participation: boolean;
    params_str: string;
    record: ActivityStatusRecord;
    short_url: string;
  };
  count: number;
}

export interface ActivityParams {
  user_id?: number;
  activity_id?: number;
  invitation_code: string;
}

// VIP v3 API接口类型定义
export interface UserVipLevelInfo {
  uuid: number;
  nickname: string;
  current_level: number;
  next_level: number;
  is_max_level: boolean;
  current_bet_amount: number;
  next_level_min_value: number;
}

export interface VipLevelConfig {
  level: number;
  name: string;
  min_value: number;
  level_promote_award: number;
  day_reward_amount: number;
  week_reward_amount: number;
  month_reward_amount: number;
}

export interface RewardInfo {
  reward_id: number;
  vip_level: number;
  reward_type: string;
  reward_amount: number;
  reward_amount_type: string;
  expire_at: number;
}

export interface PendingRewardsV1 {
  has_rewards: boolean;
  total_reward_amount: number;
  upgrade_rewards?: RewardInfo;
  daily_rewards?: RewardInfo;
  weekly_rewards?: RewardInfo;
  monthly_rewards?: RewardInfo;
}

export interface PendingRewardsV2 {
  has_upgrade_rewards: boolean;
  has_daily_rewards: boolean;
  has_weekly_rewards: boolean;
  has_monthly_rewards: boolean;
}

export type PendingRewards = PendingRewardsV1 | PendingRewardsV2;

export interface VipApiResponse {
  user_vip_level_info: UserVipLevelInfo;
  vip_level_configs: VipLevelConfig[];
  pending_rewards: PendingRewards;
  rule_content?: string;
}
import { type PddActivityContent } from "@/api/home";

// 获取活动状态
export function getActivityStatus(data: ActivityParams) {
  return request.Post("/activity/lastcycle_status", data);
}

// 获取活动详情
export function getActivityDetails(data: ActivityParams) {
  return request.Post<any>("/activity/details", data);
}

// 参加活动 新
export function joinActivity(data: any) {
  return request.Post<any>("/pdd/v3/join", data);
}

// 查询可参加的pdd 活动 新
export function pddParticipationActivity() {
  return request.Get("/pdd/v3", {
    params: { date: new Date().getTime() },
  });
}

// 领取参加的pdd 活动 奖励 新
export function pddParticipationActivityReceiveReward(data: any) {
  return request.Post("/pdd/v3/receive_reward", data);
}

// pdd 助力完成查询
export function joinList() {
  return request.Get<any>("/activity/join_list", {
    params: { date: new Date().getTime() },
  });
}

// 拼多多助力活动
export function supportActivity(params: any) {
  return request.Get<any>("/pdd/v3/support", { params });
}

// 关闭拼多多助力活动
export function closeTask(data: any) {
  return request.Post("/activity/close_task", data);
}

// 通知派发奖金
export function copyCheck(data: any) {
  return request.Post("/pdd/v3/copy_check", data);
}
// 参与活动
export function joinPddActivity(data: any) {
  return request.Post<PddActivityContent>("/activity/join", data);
}
// 显示一次弹窗
export function oncePopup() {
  return request.Get("/popup/oncePopup");
}
// 登录时显示的弹窗
export function loginPopup() {
  return request.Get("/popup/loginPopup");
}
// 首页显示的弹窗
export function homePopup() {
  return request.Get("/popup/homePopup");
}
// 判断助力弹窗是否打开
export function checkActivityPopup(invite_code: string) {
  return request.Get<any>("/activity/popup", { params: { invite_code } });
}

// 判断加油助力弹窗是否打开
export function checkActivityBoostPopup(data: any) {
  return request.Post<any>("/activity_boost/status", data);
}

// 加油活动助力
export function actionActivityBoost(data: any) {
  return request.Post<any>("/activity_boost/action", data);
}

// 判断加油活动弹窗是否打开
export function checkActivityBoost(params: any) {
  return request.Get<any>("/activity_boost/check", { params });
}

// 检查返佣参加条件
export function checkActivityRebatePopup(params: any) {
  return request.Get<any>("/rebate_activity/check", { params });
}

// 返佣活动助力
export function actionActivityRebate(params: any) {
  return request.Get<any>("/rebate_activity/assistance", { params });
}

// 获取返佣活动页面数据
export function fetchActivityRebate(params: any) {
  return request.Get<any>("/rebate/activity/v2/page/data", {
    params: { ...params, date: new Date().getTime() },
  });
}

// 获取中奖记录列表
export function fetchActivityRebateRecords(params: any) {
  return request.Get<any>("/rebate/activity/v2/winning/records", {
    params: { ...params, date: new Date().getTime() },
  });
}

// 返佣活动领取奖励
export function fetchActivityRebateAward(id: any) {
  return request.Post<any>("/rebate/activity/v2/draw/" + id);
}

// 获取返佣VIP配置列表
export function fetchActivityRebateVipConfig() {
  return request.Get<any>("/rebate/activity/v2/config", {
    params: { date: new Date().getTime() },
  });
}

// 获取返佣活动页面数据V3
export function fetchActivityRebateV3(params?: any) {
  return request.Get<any>("/rebate/activity/v3/page/data", {
    params: { ...params, date: new Date().getTime() },
  });
}

// 领取反佣奖励V3
export function claimRebateRewardV3(id: number) {
  return request.Post<any>("/rebate/activity/v3/draw", {
    id: id
  });
}

// 领取游客奖励
export function gustAward(data: any) {
  return request.Post<any>("/user/visitor/register/draw/award", data);
}

// 个人累计奖励
export function fetchInviterDetails(params?: any) {
  return request.Get<any>("/inviter/inviter_details", {
    params: { ...params, date: new Date().getTime() },
  });
}

// 平台实时奖励
export function realTimeRewards(params?: any) {
  return request.Get<any>("/inviter/real_time_rewards", {
    params: { ...params, date: new Date().getTime() },
  });
}

// 获取邀请人奖励详情
export function getInviterRewards(params?: any) {
  return request.Get<any>("/inviter/get_inviter_rewards", {
    params: { ...params, date: new Date().getTime() },
  });
}

// 获取VIP奖励列表
export function getVipRewardsList(params?: any) {
  return request.Get<any>("/inviter/get_vip_rewards_list", {
    params: { ...params, date: new Date().getTime() },
  });
}

// 获取首次充值奖励列表
export function getFirstRechargeRewardsList(params?: any) {
  return request.Get<any>("/inviter/get_first_recharge_rewards_list", {
    params: { ...params, date: new Date().getTime() },
  });
}

// 获取邀请奖励列表
export function getInviteRewardsList(params?: any) {
  return request.Get<any>("/inviter/get_inviter_records", {
    params: { ...params, date: new Date().getTime() },
  });
}

// 获取VIP v3页面数据
export function getVipPageV3Data() {
  return request.Get<VipApiResponse>("/vip/page/v3/data", {
    params: { date: new Date().getTime() },
  });
}

// 领取VIP奖励
export type VipRewardType = "upgrade" | "daily" | "weekly" | "monthly" | "all";

export function claimVipReward(rewardType: VipRewardType) {
  return request.Post<any>(
    "/vip/page/v3/reward/claim",
    {reward_type: rewardType },
  );
}

// 获取神秘金矿活动页面数据
export function getGoldMinePageData() {
  return request.Get<any>("/gold-mine/page/data", {
    params: { date: new Date().getTime() },
  });
}

export function mineGoldMine() {
  return request.Post<any>("/gold-mine/mine");
}

// 领取神秘金矿奖励
export function claimGoldMineReward(data: { reward_id: number }) {
  return request.Post<any>("/gold-mine/claim", data);
}

// --- New APIs for Missing Components ---

// Recharge Reward Types
export interface RechargeRewardActivityInfoResponse {
    data: {
        max_reward_amount: number;
        rule_content: string;
        pending_rewards?: {
            reward_id: number;
            recharge_amount: number;
            reward_amount: number;
        }
    }
}
export interface ClaimRechargeRewardResponse {
    success: boolean;
    message: string;
}

// Mystery Bonus Types
export interface MysteryBonusActivityData {
    claim_days: {
        day: number;
        is_selected: boolean;
        status: number; // 0: cannot, 1: can claim, 2: claimed
        recharge_amount: number;
        claim_time: number;
        reward_amount: number;
    }[];
    user_registered_at: number;
    rule_content: string;
    reward_configs: {
        recharge_amount: number;
        reward_min: number;
        reward_max: number;
    }[];
    can_claim: boolean;
}

// Seven Day Bet Reward Types
export interface SevenDayBetRewardData {
    day_rewards: {
        day: number;
        status: number;
        reward_amount: number;
    }[];
}
export interface SevenDayBetLevelConfig {
    // ...
}

// 获取活动列表
export function getActivityList() {
  return request.Get<any>("/activity/list?time=" + Date.now(), {
    params: { _t: Date.now() },
  });
}

export interface ActivityListConfigItem {
  id: number;
  type: number;
  foreign_name: string;
  target_url: string;
  image: string;
  remark: string;
}

export interface ActivityListConfigResponse {
  status_code: number;
  data: {
    list: ActivityListConfigItem[];
  };
  count: number;
}

export function getActivityListConfig() {
  return request.Get<ActivityListConfigResponse>("/activity-list-config/list", {
    params: { _t: Date.now() },
  });
}

// 获取充值奖励活动信息
export function getRechargeRewardActivityInfo() {
  return request.Get<RechargeRewardActivityInfoResponse>("/member/reward/activity/info", {
    params: { _t: Date.now() },
  });
}

// 领取充值奖励
export function claimRechargeReward(data: { reward_id: number }) {
  return request.Post<ClaimRechargeRewardResponse>("/activity/recharge-reward/claim", data);
}

// 获取神秘红利页面数据
export function getMysteryBonusPageData() {
  return request.Get<any>("/new-user-recharge/page/data");
}

// 领取神秘红利
export function claimMysteryBonus(data: { claim_day: number }) {
  return request.Post<any>("/new-user-recharge/claim", data);
}

// 七日投注奖励页面数据接口
export function getSevenDayBetRewardPageData() {
  return request.Get<any>("/seven-day-bet-reward/page/data?_t=" + Date.now());
}

// 领取七日投注奖励
export function receiveSevenDayBetReward(params: any) {
  return request.Post<any>("/seven-day-bet-reward/claim", params);
}

// 投注返利活动相关接口
export interface BetRewardLadder {
  bet_amount: number;
  reward_ratio: number;
}

export interface BetRewardManufacturer {
  manufacturer_id: number;
  manufacturer_name: string;
  manufacturer_icon: string;
  user_cycle_bet_amount: number;
  user_current_ratio: number;
  user_generated_reward: number;
  ladders: BetRewardLadder[];
}

export interface BetRewardGameType {
  game_type_id: number;
  game_type_name: string;
  game_type_icon: string;
  manufacturers: BetRewardManufacturer[];
}

export interface BetRewardActivityResponse {
  status_code: number;
  data: {
    user_total_reward: number;
    pending_rewards: any[];
    game_types: BetRewardGameType[];
  };
}

export function getBetRewardActivityPageData() {
  return request.Get<BetRewardActivityResponse>("/bet/reward/activity/page/data?_t=" + Date.now());
}

export function claimAllBetRewards() {
  return request.Post<any>("/bet/reward/activity/claim");
}

// 邀请活动宝箱列表相关接口
export interface TreasureChestItem {
  count: number;
  amount: number;
  index: number;
  can_receive: boolean;
  is_received: boolean;
  record_id: number;
}

export interface BonusConfigItem {
  count: number;
  amount: number;
  index: number;
}

export interface InviteConfig {
  id: number;
  status: boolean;
  invite_rules: string;
  device_limit: {
    one_device: boolean;
    virtual_device: boolean;
  };
  bonus_type: number;
  bonus_config: BonusConfigItem[];
  share_image: string;
  share_text: string;
  created_at: number;
  updated_at: number;
}

export interface TreasureChestResponse {
  treasure_chest_list: TreasureChestItem[];
  invite_config: InviteConfig;
}

export interface TreasureChestApiResponse {
  data: TreasureChestItem[];
  count: number;
}

// 获取邀请活动宝箱列表
export function getTreasureChestList() {
  return request.Get<TreasureChestApiResponse>("/inviter_v2/get_treasure_chest_list", {
    params: { _t: Date.now() },
  });
}

export function getInviterRecords() {
  return request.Get<TreasureChestApiResponse>("/inviter_v2/get_inviter_records", {
    params: { _t: Date.now() },
  });
}

// 领取邀请活动宝箱
export function openTreasureChest(data: { record_id: number }) {
  return request.Post<any>("/inviter_v2/open_treasure_chest", data);
}

export interface InviteDetailsParams {
  page: number;
  size: number;
  uuid?: string;
}

export interface InviteDetailsItem {
  date: string;
  uuid: number;
  deposit_amount: number;
  deposit_times: number;
  deposit_days: number;
  bet_amount: number;
}

export interface InviteDetailsData {
  total: number;
  list: InviteDetailsItem[];
}

export interface InviteDetailsResponse {
  data: InviteDetailsData;
  count: number;
}

// 获取邀请详情列表
export function getInviteDetails(params: InviteDetailsParams) {
  return request.Get<InviteDetailsResponse>('/inviter_v2/invited_data_list', { params });
}

export interface InviteCenterResponse {
  data: {
    my_commission: {
      received_commission: number;
      today_commission: number;
    };
    my_data: {
      new_subordinates: number;
      new_direct_subordinates: number;
      other_new_subordinates: number;
      deposit_total: number;
      deposit_count: number;
      first_deposit_total: number;
      first_deposit_count: number;
      non_first_deposit_total: number;
      non_first_deposit_count: number;
      withdrawal_total: number;
      withdrawal_count: number;
    };
    performance: {
      total_performance: number;
      direct_performance: number;
      other_performance: number;
      direct_valid_bet: number;
      direct_profit_loss: number;
      direct_deposit: number;
      direct_withdrawal: number;
    };
    total_commission: {
      total_amount: number;
      received_amount: number;
      unreceived_amount: number;
      direct_commission: number;
      other_commission: number;
    };
  };
  count: number;
}

// 获取推广中心数据
export function getInviteCenterData(params?: { period?: string }) {
  return request.Get<InviteCenterResponse>("/inviter_v2/center", { params });
}

export interface PerformanceItem {
  uuid: number;
  subordinate_count: number;
  bet_amount: number;
  performance: number;
  deposit_amount: number;
}

export interface PerformanceListResponse {
  data: {
    total: number;
    list: PerformanceItem[];
  };
  count: number;
}

// 获取业绩列表
export function getPerformanceList(params: { page: number; size: number; date?: string; uuid?: string }) {
  return request.Get<PerformanceListResponse>("/inviter_v2/performance_list", { params });
}

export interface CommissionItem {
  date: string;
  type: string;
  performance: number;
  invite_count: number;
  commission: number;
}

export interface CommissionListResponse {
  data: {
    list: CommissionItem[];
  };
  count: number;
}

// 获取佣金记录列表
export function getCommissionList(params: { start_date?: string; end_date?: string }) {
  return request.Get<CommissionListResponse>("/inviter_v2/commission_records", { params });
}

export function claimCommission() {
  return request.Post<any>("/inviter_v2/claim_commission");
}

export interface RewardRuleItem {
  level: number;
  bet_amount: number;
  reward_ratio: number;
}

export interface RewardRuleResponse {
  data: {
    list: RewardRuleItem[];
  };
  count: number;
}

export interface InviteRecordV2 {
  amount: number;
  uuid: string;
  created_at: number;
}

export interface InviterRecordsResponse {
  status_code: number;
  data: {
    total_invite_count: number;
    total_effective_invitee_count: number;
    invite_record_v2s: InviteRecordV2[];
  };
  count: number;
}

// 获取活动历史记录 (已领取奖励)
export function getActivityHistoryList(params: any) {
  return request.Get<any>("/activity/reward/claimed", {
    params: { ...params, _t: Date.now() },
  });
}

// 获取活动待领取记录
export function getActivityPendingList(params: any) {
  return request.Get<any>("/activity/reward/pending", {
    params: { ...params, _t: Date.now() },
  });
}

// 获取奖励规则列表
export function getRewardRules() {
  return request.Get<RewardRuleResponse>("/inviter_v2/reward_rules");
}


// 领取所有奖励
export function rewardClaimAll(){
  return request.Post<any>('/activity/reward/claim_all',)
}

export interface FirstDepositRewardConfigItem {
  deposit_amount: number;
  reward_amount: number;
  index: number;
}

export interface FirstDepositRewardData {
  pending_reward_amount: number;
  qualified_count: number;
  can_claim: boolean;
  reward_config: FirstDepositRewardConfigItem[];
  bonus_type: number;
}

export interface FirstDepositRewardResponse {
  status_code: number;
  data: FirstDepositRewardData;
  count: number;
}

export function getFirstDepositReward() {
  return request.Get<FirstDepositRewardResponse>("/inviter_v2/first_deposit_reward", {
    params: { _t: Date.now() },
  });
}

export function claimFirstDepositReward() {
  return request.Post<any>("/inviter_v2/claim_first_deposit_reward");
}

export interface InviteConfigV2Data {
  deposit_required: number;
  bet_required: number;
  invite_rules: string;
  share_image: string;
  share_text: string;
}

export interface InviteConfigV2Response {
  status_code: number;
  data: InviteConfigV2Data;
  count: number;
}

export function getInviteConfigV2() {
  return request.Get<InviteConfigV2Response>("/inviter_v2/invite_config", {
    params: { _t: Date.now() },
  });
}
